import Vue from 'vue';
import Vuex from 'vuex';
import userModule from './modules/user';
import errorsModule from './modules/errors';
import contentTypes from './modules/contentTypes';
import notifications from './modules/notifications';
import corrTypes from './modules/corrTypes';
import roles from './modules/roles';
import uploadManager from './modules/uploadManager';
import memoryGame from './modules/memoryGame';
import quizGame from './modules/quizGame';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: userModule,
    errors: errorsModule,
    contentTypes,
    notifications,
    corrTypes,
    roles,
    uploadManager,
    memoryGame,
    quizGame,
  },

  state: {
    homeSections: ['Ellen White', 'Writings', 'Apps', 'Resources', 'FAQ', 'About', 'Visit'],
  },

  mutations: {
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js